import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiHandlerService } from 'projects/b2c/src/app/core/api-handlers';
import { UtilityService } from 'projects/b2c/src/app/core/services/utility.service';
import { SubSink } from 'subsink';
import { HotelService } from '../../../../hotel.service';

@Component({
    selector: 'app-hotel-confirmation',
    templateUrl: './hotel-confirmation.component.html',
    styleUrls: ['./hotel-confirmation.component.scss']
})
export class HotelConfirmationComponent implements OnInit {

    protected subSink = new SubSink();
    hotelDetails: any;
    paxDetails: any;
    roomDetails: any;
    bookingDetails: any;
    leadPax: any;
    totalFare: any = 0;
    nights: any;
    appReference: string = "";
    currentUser: any;
    bookingSource: any;
    orderId: any;
    loading: boolean;
    loadingTemplate: any;
    primaryColour: any;
    secondaryColour: any;
    constructor(
        private hotelService: HotelService,
        private util: UtilityService,
        private apiHandlerService: ApiHandlerService,
        private router: Router,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            console.log("params",params)
            this.appReference = (params.AppReference)
            this.bookingSource = (params.BookingSource)
            this.orderId = (params.OrderId)
        })

        let req = {
            app_reference: this.appReference,
            order_id: this.orderId
        }
        this.intializeValue()
       // this.reservation();
        // this.subSink.sink = this.apiHandlerService.apiHandler('hotelPaymentConfirmation', 'post', {}, {},
        //     req).subscribe(resp => {
        //         if (resp.statusCode == 201 && resp.data) {
        //             this.reservation();
        //         } else {
        //             this.router.navigate(['/hotel-payment'], { queryParams: { appReference: this.appReference } });
        //         }
        //     })
    }

    reservation() {
        this.loading=true;
        console.log(this.appReference)
        this.subSink.sink = this.apiHandlerService.apiHandler('reservation', 'post', {}, {}, {
            AppReference: this.appReference,
            booking_source: "ZBAPINO00008"
        }).subscribe(resp => {
            if (resp.statusCode == 200) {
                this.loading =false;
                console.log(resp)
                this.currentUser = this.util.getStorage('b2cUser');
                let totalFare: any = 0;
                resp.data["BookingItineraryDetails"].forEach(itinerary => {
                    totalFare += itinerary.RoomPrice;
                });
                let balance = String(this.currentUser.agent_balance - totalFare);
                this.subSink.sink = this.apiHandlerService.apiHandler('updateSubAgent', 'post', {}, {}, {
                    id: this.currentUser.id,
                    agent_balance: balance
                }).subscribe(res => {
                    if (resp.statusCode == 201) {
                        this.subSink.sink = this.apiHandlerService.apiHandler('getAgentById', 'post', {}, {}, {
                            id: this.currentUser.id
                        }).subscribe(data => {
                            res['data']['access_token'] = this.currentUser.access_token;
                            sessionStorage.setItem('b2cUser', JSON.stringify(res['data']));
                        });
                    }
                })
                this.cdr.detectChanges();
                this.hotelService.hotelConfirmationData.next(resp.data);
           
            } else {
                setTimeout(() => {
                    this.router.navigate(['/']);
                }, 100);
            }
        }, err => {
            console.error(err);
        })
        this.cdr.detectChanges();
        this.hotelService.loading.next(false);
    }

    intializeValue() {
        // this.loading=true;
        this.subSink.sink = this.hotelService.hotelConfirmationData.subscribe(data => {
            // this.loading=true;
            console.log(data);
            this.hotelDetails = data;
            this.paxDetails = this.hotelDetails.BookingPaxDetails;
            this.bookingDetails = this.hotelDetails.BookingDetails;
            this.leadPax = this.paxDetails[0];
            this.roomDetails = this.hotelDetails.BookingItineraryDetails;
            this.roomDetails.forEach(element => {
                this.totalFare += element.TotalFare;
            });
            this.nights = this.util.noOfNights(this.bookingDetails.HotelCheckIn, this.bookingDetails.HotelCheckOut);
            console.log(this.leadPax)
            this.cdr.detectChanges();
        })
    }

    // getCancelationPolicy(cancellationPolicy) {
    //     let policy = JSON.parse(cancellationPolicy.replace(/'/gi, "\""));
    //     if (policy['NonRefundable']) {
    //         return `Non Refundable`;
    //     } else if (!policy['NonRefundable']) {
    //         let penalty = '';
    //         if (typeof policy['CancelPenalty'] == 'object') {
    //             policy['CancelPenalty'].forEach((element, i) => {
    //                 penalty += `Cancellation made <strong>${element.HoursBefore} hours</strong> before checkin <strong>${this.bookingDetails.Currency + ' ' + element.Penalty.Value}</strong> will be charged as cancellation penalty`;
    //                 if (policy['CancelPenalty'].length - 1 != i) {
    //                     penalty += '<br>'
    //                 }
    //             });
    //             return penalty;
    //         } else {
    //             penalty += `You may cancel your booking for <strong>no charge</strong> on or before <strong>${policy['CancelPenalty']}</strong>`;
    //             return penalty;
    //         }
    //     }
    // }

    goToVoucher(appRef: any) {
        this.router.navigate(['/hotel-voucher'], { queryParams: { AppReference: appRef, booking_source: this.bookingSource } });
    }

}